import { PublicPurchaseMotionCTA } from 'purchase-motions-components/components/PublicPurchaseMotionCTA/PublicPurchaseMotionCTA';
import { getNonMerchandiseIdProduct } from 'purchase-motions-components/utils/productIdentifier';
import { isPublicNavItem } from '../types/PublicNavItem';
import { TRACKING_SOURCES, trackPurchaseMotionClick } from '../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
function isKnownTrackingSource(source) {
  const knownSources = Object.values(TRACKING_SOURCES);
  return knownSources.includes(source) || isPublicNavItem(source) || source.endsWith('-feature-table');
}
function toTrackingSource(source) {
  if (source && isKnownTrackingSource(source)) return source;
  return TRACKING_SOURCES.PRICING_PAGES;
}

/*
 * The advanced purchase-request shape accepted by the touchless buy button.
 * Pulled off the library's own CTA prop type so it stays in sync with
 * RequestedProductV2 without importing the package's internal generated path.
 */

export const PublicPurchaseMotionCTAWrapper = ({
  purchaseMotion,
  trackingData,
  productApiName,
  location,
  displayIndex,
  disabled,
  children,
  uiButtonProps,
  currencyCode,
  paymentTerm,
  commitmentTerm,
  eligibleTreatments,
  purchaseRequest: purchaseRequestFromProps,
  onClick
}) => {
  const trackingSource = toTrackingSource(trackingData.source);
  const nonMerchandiseIdProduct = getNonMerchandiseIdProduct(productApiName);
  const buttonVariant = displayIndex === 0 ? 'primary' : 'secondary';
  const purchaseRequest = purchaseRequestFromProps !== null && purchaseRequestFromProps !== void 0 ? purchaseRequestFromProps : {
    products: [{
      productApiName,
      skuQuantity: 1
    }],
    quantityPacks: [],
    currencyCode,
    commitmentTerm,
    paymentTerm
  };
  const productNames = purchaseRequest.products.map(p => p.productApiName);
  return /*#__PURE__*/_jsx(PublicPurchaseMotionCTA, {
    "data-selenium-id": `${trackingSource}-${nonMerchandiseIdProduct}-${String(purchaseMotion)}-button`,
    apiName: productApiName,
    trackingData: Object.assign({}, trackingData, {
      source: trackingSource,
      uniqueId: trackingData.uniqueId || 'pricing-hero'
    }),
    location: location,
    onClick: () => {
      trackPurchaseMotionClick({
        productApiName,
        purchaseMotion: String(purchaseMotion),
        activeCurrencyCode: String(currencyCode),
        productNames,
        screen: isPublicNavItem(trackingData.screen) ? trackingData.screen : undefined,
        trackingSource
      });
      onClick === null || onClick === void 0 || onClick();
    },
    uiButtonProps: Object.assign({
      disabled: disabled !== null && disabled !== void 0 ? disabled : false,
      use: buttonVariant,
      block: true,
      truncate: true
    }, uiButtonProps),
    purchaseMotion: purchaseMotion,
    ctaProps: {
      purchaseRequest,
      eligibleTreatments: eligibleTreatments !== null && eligibleTreatments !== void 0 ? eligibleTreatments : []
    },
    children: children
  });
};